const steps = [
  {
    icon: 'ri-search-eye-line',
    title: '第一步 · 找对场景',
    desc: '点进「表情大全」，用顶部的搜索框输入你想要的情绪关键词，比如「震惊」「蹲后续」，秒级匹配最合适的吃瓜表情。',
    color: 'text-primary-600 bg-primary-100',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '第二步 · 一键保存',
    desc: '点击任意表情卡片即可放大预览。确认表情包后直接保存到手机相册，或是动图专区保存为本地素材，随取随用。',
    color: 'text-accent-700 bg-accent-100',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '第三步 · 聊天开怼',
    desc: '在微信群、评论区或私聊里甩出表情包，配上一句「吃瓜群众集合」，气氛瞬间拉满，围观更带劲。',
    color: 'text-secondary-900 bg-secondary-100',
  },
];

export default function Guide() {
  return (
    <section id="guide" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-question-answer-line" /> 三步上手
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">表情包使用攻略</h2>
          <p className="mt-3 text-base text-foreground-700">
            不会用？跟着这三步走，从找图到甩图，一套流程轻松搞定，人人都能当吃瓜王。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {steps.map((s) => (
            <article
              key={s.title}
              className="rounded-2xl border border-background-200 bg-background-50 p-6"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${s.color}`}>
                <i className={s.icon} />
              </span>
              <h3 className="mt-5 font-heading text-lg text-foreground-950">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-4 rounded-2xl bg-primary-500 p-6 text-center md:flex-row md:text-left">
          <div className="flex-1">
            <h3 className="font-heading text-xl text-background-50">现在就去挑一张最对味的表情包吧</h3>
            <p className="mt-1 text-sm text-background-50/80">海量吃瓜专用表情等你翻牌，聊天开怼不愁没素材。</p>
          </div>
          <button
            onClick={() => document.getElementById('library')?.scrollIntoView({ behavior: 'smooth' })}
            className="whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-600 transition-colors hover:bg-background-100"
          >
            开始挑选
          </button>
        </div>
      </div>
    </section>
  );
}